import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import TeamAvatar from '@sorare/core/src/components/club/TeamAvatar';

import { BaseLayout } from 'components/rivals/Onboarding/FavoriteClubSelection/ClubSelectionDialog/BaseLayout';

import { WelcomeToSorare_club } from './__generated__/index.graphql';

type Props = { club?: WelcomeToSorare_club };
export const WelcomeToSorare = ({ club }: Props) => {
  return (
    <BaseLayout
      color={club?.styleGuideColor}
      title={
        <FormattedMessage
          id="ClubSelectionDialog.title"
          defaultMessage="Welcome to Sorare"
        />
      }
      subtitle={
        <FormattedMessage
          id="ClubSelectionDialog.subtitle"
          defaultMessage="A fantasy game based on real life scoring."
        />
      }
      content={
        <Horizontal center>
          <TeamAvatar team={club} size={160} />
        </Horizontal>
      }
    />
  );
};

WelcomeToSorare.fragments = {
  club: gql`
    fragment WelcomeToSorare_club on Club {
      slug
      id
      styleGuideColor
      ...TeamAvatar_team
    }
    ${TeamAvatar.fragments.team}
  ` as TypedDocumentNode<WelcomeToSorare_club>,
};
